import { Controller } from "@hotwired/stimulus";

// Shows save status feedback for auto-submitted forms
export default class extends Controller {
  static targets = ["status", "icon"];
  static values = {
    savingText: { type: String, default: "Saving..." },
    savedText: { type: String, default: "All changes saved" },
    errorText: { type: String, default: "Error saving" },
  };

  connect() {
    this._form = this.element.closest("form");
    if (this._form) {
      this._onStart = () => this._saving();
      this._onEnd = (e) => this._saved(e);
      this._form.addEventListener("turbo:submit-start", this._onStart);
      this._form.addEventListener("turbo:submit-end", this._onEnd);
    }
  }

  disconnect() {
    if (this._form) {
      this._form.removeEventListener("turbo:submit-start", this._onStart);
      this._form.removeEventListener("turbo:submit-end", this._onEnd);
    }
  }

  // Private

  _saving() {
    this.statusTarget.textContent = this.savingTextValue;
    this.iconTarget.textContent = "sync";
  }

  _saved(event) {
    if (event.detail?.success) {
      this.statusTarget.textContent = this.savedTextValue;
      this.iconTarget.textContent = "check_circle";
    } else {
      this.statusTarget.textContent = this.errorTextValue;
      this.iconTarget.textContent = "error";
    }
  }
}
